import { useState, useEffect, Fragment, useContext } from 'react';
import { MapPinIcon, CalendarDaysIcon } from '@heroicons/react/20/solid';
import MapAddress from '../MapAddress';
import ReviewList from '../Review/List';
import LoadingScreen from '../skeletonLoading/DetailJasaSL';
import { getHideAddons, getServiceDetails } from '../../API/ServiceAPI';
import { useParams, Link } from 'react-router-dom';
import { numberFormat, hourFormat, showToast } from '../../Utils';
import { ReactSVG } from 'react-svg';
import NumberWithButtons from '../NumberWithButtons';
import DatePicker from '../DatePicker';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { format, startOfDay, startOfToday } from 'date-fns';
import {
  getServiceSchedule,
  getServiceDailySchedule,
  getListAddon
} from '../../API/ServiceAPI';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import ScheduleDialog from '../dialog/ScheduleDialog';
import MaintenanceModal from './MaintenanceModal';

const VenueDetail = () => {
  const [venue, setVenue] = useState();
  const venueId = useParams().id;


  const [selectedDate, setSelectedDate] = useState(null);
  const [schedule, setSchedule] = useState([]);
  const [addons, setAddons] = useState([]);
  const [addonsResponse, setAddonsResponse] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState([]);
  const [serviceFee, setServiceFee] = useState(0);
  const [showScheduleAddon, setShowScheduleAddon] = useState([]);
  const [selectedCourt, setSelectedCourt] = useState(null);
  const [fetchSchedule, setFetchSchedule] = useState(false);
  const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);

  const [currentTimeServer, setCurrentTimeServer] = useState(null);


  // Pertama: ambil detail venue dan waktu server
  useEffect(() => {
    const onSuccessHandler = (responseJSON) => {
      setVenue(responseJSON);
      setSelectedCourt(responseJSON.fields[0]);

      const timeServer = new Date(responseJSON.current_timestamp.replace(' ', 'T'));
      setCurrentTimeServer(timeServer);

      // langsung set selectedDate, tanpa setTimeout
      setSelectedDate(startOfDay(timeServer));
    };

    const onFailureHandler = (messages) => console.debug("FAIL", messages);

    getServiceDetails(venueId, onSuccessHandler, onFailureHandler);
  }, [venueId]);

  useEffect(() => {
    if (venue && selectedDate) {
      getListAddon(
        venue.user_admin_id,
        (responseJSON) => {
          setAddons(responseJSON);
          setAddonsResponse(responseJSON);
        },
        (messages) => console.debug("FAIL getListAddon", messages)
      );
    }
  }, [venue, selectedDate]);


  function updateAvailability(times) {
    var tmpTimes = [...times];
    const currentDate = currentTimeServer;
    if (format(selectedDate, 'yyyy-MM-dd') === format(currentDate, 'yyyy-MM-dd')) {
      const currentHour = currentDate.getHours();
      tmpTimes.forEach((item, index) => {
        const slotHour = parseInt(item.hour.split(":")[0]);
        if (slotHour <= currentHour) {
          tmpTimes[index].available = false;
        }
      });
    }
    return times;
  }

  useEffect(() => {
    if (selectedDate != null && selectedCourt !== null) {
      getServiceDailySchedule(
        selectedCourt.id,
        selectedDate,
        (responseJSON) => {
          setFetchSchedule(true)
          setServiceFee(responseJSON.service_fee)
          setSchedule(updateAvailability(responseJSON.times))
          const selectedDateStr = format(selectedDate, 'yyyy-MM-dd');
          setAddons(addonsResponse);
        },
        (messages) => console.debug("FAIL", messages)
      )
    }
  }, [selectedDate, selectedCourt]);

  const passingDataToCheckout = () => ({
    venue: {
      id: selectedCourt?.id,
      name: selectedCourt?.name,
      isDP: selectedCourt?.is_dp,
      user_admin_id: selectedCourt?.user_admin_id,
    },
    service_fee: serviceFee,
    selected_date: selectedDate,
    selected_schedule: schedule.filter(item => selectedSchedule.includes(item.hour)),
    addons: addons.filter(item => item.qty > 0)
  });

  const onDaySelected = (day) => {
    setSelectedDate(day);
    setSelectedSchedule([]);
  }

  const scheduleSelected = (data) => {
    const selectedSchedules = [...selectedSchedule];

    // Tentukan pasangan jam yang perlu di-handle bersama
    const linkedHours = {
      // "21:00 - 22:00": "22:00 - 23:00",
      // "22:00 - 23:00": "21:00 - 22:00",
    };

    const currentHour = data.hour;
    const linkedHour = linkedHours[currentHour]; // bisa undefined jika tidak ada pasangannya

    const isSelected = selectedSchedules.includes(currentHour);

    if (isSelected) {
      // Hapus currentHour dan linkedHour (jika ada)
      const updatedSchedules = selectedSchedules.filter(hour => hour !== currentHour && hour !== linkedHour);
      setSelectedSchedule(updatedSchedules);
    } else {
      // Tambahkan currentHour dan linkedHour (jika ada)
      const updatedSchedules = [...selectedSchedules];
      if (!updatedSchedules.includes(currentHour)) {
        updatedSchedules.push(currentHour);
      }
      if (linkedHour && !updatedSchedules.includes(linkedHour) && schedule.find(item => item.hour === linkedHour && item.available)) {
        updatedSchedules.push(linkedHour);
      }
      setSelectedSchedule(updatedSchedules);
    }
  };


  const checkSchedule = (schedule) => {
    return (selectedSchedule.length > 0) && (selectedSchedule.filter((selectedHour) => selectedHour === schedule.hour).length > 0)
  }

  const updateAddon = (addon, qty) => {
    const selectedAddons = [...addons];
    if (qty >= 0) {
      selectedAddons.find(selectedAddon => selectedAddon.id === addon.id).qty = qty;
    }
    setAddons(selectedAddons);
  }

  const validate = () => {
    if (schedule.filter(item => selectedSchedule.includes(item.hour)).length <= 0)
      return { valid: false, msg: "Silahkan pilih jadwal" };

    return { valid: true, msg: "OK" };
  }

  const onNext = () => {
    let { valid, msg } = validate();

    // if (valid) {
    //   props.onNextPageConfirmed();
    // } else {
    //   showToast("Error", "Alert", msg);
    // }
  }


  const diffDate = (day1, day2) => {
    if (!day1 || !day2) return 0;

    const date1 = new Date(day1);
    const date2 = new Date(day2);

    // Set ke awal hari tanpa memodifikasi aslinya
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    const diffInMs = date1 - date2;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays;
  };



  const daysDifference = diffDate(selectedDate, currentTimeServer);
  const canShowAddons = daysDifference >= 1;


  const checkAvailable = (item) => {
    const isHaveSchedule = item.add_on_item_schedules.length > 0;
    const hasMatchingSchedule = item.add_on_item_schedules.filter(schedule =>
      schedule.date_available === format(selectedDate, 'yyyy-MM-dd')
    );
    const scheduleHours = hasMatchingSchedule.map(schedule => `${schedule.start_time} - ${schedule.end_time}`);
    const isAvailable = selectedSchedule.length > 0 && selectedSchedule.every(item => scheduleHours.includes(item));
    return !isHaveSchedule || isAvailable;
  }

  const checkDateCloses = (dateString) => {
    if (!selectedCourt || !selectedCourt.service_closes) return undefined;

    const formattedInputDate = format(dateString, 'yyyy-MM-dd');
    return selectedCourt.service_closes.find(item => item.date_closed === formattedInputDate);
  };

  if (!fetchSchedule || venue === undefined || selectedCourt === null || selectedDate == null || currentTimeServer == null) {
    return <LoadingScreen />;
  } else {
    return (
      <div className="">

        {/* Venue Details */}
        <div className="flex flex-col overflow-hidden rounded-2xl">

          {/* venue detail right pane */}

          {/* Image gallery */}
          <div className="w-full relative flex h-72 mb-20 md:mb-0">
            {/* <div className='absolute inset-0 bg-gradient-to-r from-gray-900 opacity-75'></div> */}
            <img
              src="/bg-mask-venuedetai.png"
              alt={venue.description}
              className="w-full absolute inset-0 z-20 object-cover h-72"
            />

            {/* <PhotoView src={venue.cover}> */}
            <img
              src={venue.cover}
              alt={venue.description}
              className="w-full absolute inset-0 z-10 object-cover h-72"
            />
            {/* </PhotoView> */}

            <div className='w-full flex flex-col justify-center h-72 md:mt-4 absolute inset-0 z-30 w-full px-6 text-white'>

              <div className='flex flex-col md:px-4 gap-y-3 text-[#946363]'>
                <div className='flex items-center text-sm'>
                  <ReactSVG
                    src={`/sport-type/light/ic-${venue.sport_type.replaceAll(" ", "-").toLowerCase()}.svg`}
                    afterInjection={(svg) => {
                      svg.setAttribute('fill', '#946363');
                      svg.setAttribute('height', '18');
                      svg.setAttribute('width', '18');
                    }}
                    className="mr-2" />
                  <p className='font-semibold'>
                    {venue.sport_type}
                  </p>
                </div>

                <p className='text-2xl font-bold mr-4'>
                  {venue.name}
                  {/* {new Date(currentTime).toLocaleString('en-US', { timeZone: 'Asia/Jakarta' })} */}
                </p>

                <div className='flex flex-wrap gap-x-4 gap-y-2 w-full items-center'>
                  <div className='flex items-center'>
                    <MapPinIcon className='w-4 grow-0 shrink-0' />
                    <p className='ml-1 text-sm'>
                      {venue.location}
                    </p>
                  </div>
                  {/* <div className='w-1/2 flex items-center'>
                  <img src='/ic_lapang.svg' className='mr-1 w-4 object-contain' />
                  <p className='ml-1 text-sm'> {venue.available_session} Sesi Tersedia </p>
                </div> */}
                </div>

                <p className='mt-6 text-xs'>Jam Operasional</p>
                <p className='text-sm font-semibold'>
                  {venue.day_of_service} &nbsp;&nbsp;
                  {hourFormat(venue.open_hour)} - {hourFormat(venue.close_hour)}</p>
              </div>
            </div>

            {/* <div className='items-center text-sm absolute w-full md:w-auto top-full md:top-auto left-0 md:left-auto md:right-10 md:bottom-0 z-30 text-white bg-[#e19b9b] px-6 py-5 md:rounded-tl-xl md:rounded-tr-xl'>
            <p>Mulai dari</p>
            <span className='text-xl font-bold'>{numberFormat(venue.start_from)}</span>
            <span className='text-xs py-0.5 px-2 font-semibold'>/ Sesi</span>
          </div> */}


          </div>


          {/* venue detail left pane */}
          <div className='flex flex-col px-6 bg-white pt-[43px] pb-[43px]'>
            <div className='flex flex-col md:flex-row'>
              <div className='w-full md:w-1/2 md:px-4 '>

                <p className='font-semibold text-md tracking-wide text-gray-800 mb-4'>Tentang Lapang</p>

                <p className='text-sm text-gray-800 tracking-wide leading-loose'>
                  {venue.description}
                </p>

                <p className='font-semibold text-md tracking-wide text-gray-800 mt-8 mb-4'>Lokasi</p>
                <div className='flex w-full map-container'>
                  <MapAddress venue={venue} />
                </div>
                <p className=' text-md tracking-wide mt-4 text-gray-800'>
                  <span className='font-semibold'> {venue.name} : </span> <span>{venue.location}</span>
                </p>

              </div>

              <div className='flex flex-col w-full md:w-1/2  md:ml-4'>
                <p className='font-semibold text-md tracking-wide text-gray-800 mb-4'>Fasilitas</p>

                {/* venue facility */}
                <div className='grid grid-cols-2 gap-4 mb-4'>
                  {('facilities' in venue && venue.facilities !== null) && venue.facilities.split(', ').map((facility, index) => (
                    facility !== "" && (
                      <div key={index} className='text-gray-800 font-semibold flex items-center text-sm'>
                        <img src={`/facilities/dark/ic-${facility.replaceAll(" ", "-").toLowerCase()}.svg`} alt={facility}
                          className='w-8 h-8 mr-2 p-1.5 bg-primaryRed rounded-full' /> {facility}
                      </div>
                    )
                  ))}
                </div>

                <div className='grid grid-cols-4 gap-4'>
                  {venue.images.map((attachment, index) => {
                    return (

                      <PhotoView src={attachment.url}>
                        <img key={attachment.id} className='w-full aspect-square rounded-xl'
                          src={attachment.url} alt={`Venue gallery #${index}`} />
                      </PhotoView>
                    )
                  })}

                </div>

              </div>
            </div>

          </div>

        </div>


        {/* Venue Details Package List */}
        <div className="flex flex-col overflow-hidden rounded-2xl mt-6 px-6 md:px-[40px] bg-white pt-[37px] pb-[37px]">

          <div className='flex w-full flex-col'>

            <div className='flex flex-col'>
              <div className='flex justify-between'>
                <p className='text-md font-semibold mb-4'>Pilih Lapang</p>
              </div>

              {/* <ScheduleListSL /> */}
              <div className='flex flex-col px-1 grid grid-cols-2 gap-4 lg:grid-cols-3'>

                {venue.fields.map((item, index) => {
                  return (
                    <div key={index} onClick={(e) => { setSelectedCourt(item) }} className={item === selectedCourt ? 'flex items-center justify-between w-full border border-primaryRed text-white text-sm rounded-lg py-2 pl-4 pr-2 cursor-pointer bg-primaryRed' : 'flex items-center justify-between w-full border border-primaryRed text-primaryRed text-sm rounded-lg py-2 pl-4 pr-2 cursor-pointer'}>

                      <div className='flex-col'>
                        <p className='text-[15px] font-bold'>{item.name}</p>
                      </div>

                      <span className=' flex items-center font-semibold'>
                        {item === selectedCourt ?
                          <CheckCircleIcon className='w-6 text-white ml-2' />
                          :
                          <CheckCircleIcon className='w-6 text-gray-300 ml-2' />
                        }
                      </span>
                    </div>
                  )
                })}



              </div>



            </div>

            <div className='md:flex md:gap-6 w-full mt-8'>
              <div className='md:w-2/5 mb-4 md:mb-0 flex flex-col'>
                <p className='text-md font-semibold mb-4'>Pilih Tanggal</p>

                <div className=''>
                  <DatePicker
                    className='flex w-1/2'
                    today={startOfDay(currentTimeServer)}
                    selectedDate={selectedDate}
                    onDaySelected={onDaySelected} />
                  {/* scheduleClosedList={selectedCourt.service_closes} /> */}
                </div>

              </div>

              <div className='md:w-3/5 flex flex-col'>
                {checkDateCloses(selectedDate) !== undefined ? (<div className='mt-10'>
                </div>) : (<div className='flex justify-between'>
                  <p className='text-md font-semibold mb-4'>Pilih Jam</p>
                </div>)}



                {(checkDateCloses(selectedDate) !== undefined || schedule.length === 0) ? (
                  <div className="flex items-center h-full justify-center space-x-4 bg-white p-6 rounded-xl border border-gray-200">
                    {/* Icon container */}
                    <div className="flex items-center justify-center w-16 h-16">
                      <img src="/ic_closed.png" alt="Closed Icon" className="w-full h-full" />
                    </div>
                    {/* Text content */}
                    <div>
                      <h2 className="text-[20px] font-semibold text-gray-500">Lapangan Tutup</h2>
                      <p className="text-[15px] text-gray-400 mt-1">{checkDateCloses(selectedDate)?.description ?? `Belum ada jadwal tersedia`}</p>
                    </div>
                  </div>
                ) : (
                  <div className='flex flex-col px-1 grid grid-cols-2 gap-4 lg:grid-cols-3'>

                    {schedule.map((item, index) => {
                      if (item.available === true) {
                        return (
                          <div key={index} onClick={(e) => { scheduleSelected(item) }} className={checkSchedule(item) ? 'flex items-center justify-between w-full border border-primaryRed text-white text-sm rounded-lg py-2 pl-4 pr-2 cursor-pointer bg-primaryRed' : 'flex items-center justify-between w-full border border-primaryRed text-primaryRed text-sm rounded-lg py-2 pl-4 pr-2 cursor-pointer'}>

                            <div className='flex-col'>
                              <p className='text-[15px] font-bold'>{item.hour}</p>
                              {
                                new Date(item.promo_period_end) >= selectedDate ? (
                                  <>
                                    <p className='text-sm line-through'>Rp{numberFormat(item.price, false)}</p>
                                    <p className='text-sm'>Rp{numberFormat(item.promo_price, false)}</p>
                                  </>
                                ) : (
                                  <>
                                    <p className='text-sm'>Rp{numberFormat(item.price, false)}</p>
                                  </>
                                )
                              }

                            </div>

                            <span className=' flex items-center font-semibold'>
                              {/* {numberFormat(data.package.price)} */}

                              {checkSchedule(item) ?
                                <CheckCircleIcon className='w-6 text-white ml-2' />
                                :
                                <CheckCircleIcon className='w-6 text-gray-300 ml-2' />
                              }
                            </span>
                          </div>
                        )
                      } else {
                        return (
                          <div key={index} className='flex items-center justify-between w-full bg-gray-200 border text-gray-400 text-sm  rounded-lg p-4'>
                            <p className='text-[15px] font-bold'>{item.hour}</p>
                          </div>
                        )
                      }

                    })}



                  </div>)}



              </div>
            </div>

            {addons.length > 0 && (<div className='mt-8' >
              <p className='text-md font-semibold mb-4'>Tambah Add On</p>

              {!canShowAddons ? (<>
                Tanggal booking minimal H-1 untuk pemesanan dengan add on.
              </>) : (<>
                <div className='grid md:grid-cols-2 md:border md:border-gray-200 md:rounded-lg overflow-hidden'>

                  {addons.map((addon) => (
                    <div key={addon.id} className="relative flex flex-col p-4 border border-gray-200">
                      {/* Calendar icon top-right */}
                      {addon.add_on_item_schedules.length > 0 && (<button
                        className="absolute top-2 right-2 p-2 hover:bg-gray-100 rounded-full transition"
                        onClick={() => {
                          setShowScheduleAddon(addon.add_on_item_schedules);
                        }}
                      >
                        <CalendarDaysIcon className="w-8 h-8 text-gray-500" />
                      </button>)}

                      <div className="flex flex-grow items-start">
                        <img
                          src={`${process.env.REACT_APP_API_DOMAIN}${addon.image.thumb.url}`}
                          alt={`icon ${addon.name}`}
                          className="w-[30%] max-w-20 h-auto object-contain mr-4 self-start"
                        />
                        <div className="flex-grow flex flex-col">
                          <p className="font-semibold mb-2 text-sm">{addon.name}</p>
                          <p className="font-semibold mb-4 text-sm">
                            Rp{numberFormat(addon.price, false)} / {addon.unit}
                          </p>
                          <div className="flex flex-wrap gap-2 items-center">
                            <NumberWithButtons
                              onChange={(value) => updateAddon(addon, value)}
                              isEnable={checkAvailable(addon)}
                            />
                            {addon.unit === "Hour" && (
                              <div className="font-semibold text-sm self-center">x Hour</div>
                            )}
                          </div>

                          <p className="font-semibold mt-4 text-sm">{addon.note}</p>
                        </div>
                      </div>
                    </div>

                  ))}
                </div></>)}

            </div>)}


            <div className='flex w-full justify-end'>
              <button
                onClick={(e) => {
                  // let { valid, msg } = validate();
                  // if (!valid) {
                  //   e.preventDefault();
                  //   showToast("Error", "Alert", msg);
                  // } else {
                  setShowMaintenanceModal(true);
                  // }
                }}
                className='w-full md:w-fit bg-primaryRed text-white rounded-lg px-10 py-3 text-sm font-semibold mt-4 mb-8'>
                <p className='text-center'>Konfirmasi Pesanan</p>
              </button>

            </div>
          </div>

          <div className='bg-[#F5F5F5] rounded-2xl'>
            <p className='font-semibold text-sm tracking-wide text-gray-900 p-4'>Kebijakan Booking Lapang</p>
            <p className='text-gray-700 text-xs tracking-wide leading-loose'>
              <div
                className='rich-text-container'
                dangerouslySetInnerHTML={{ __html: venue.terms_of_service }}
              />
            </p>
          </div>
        </div>

        <ReviewList venueId={selectedCourt?.id} />

        <ScheduleDialog venueId={selectedCourt?.id} scheduleAddon={showScheduleAddon} onClose={() => {
          setShowScheduleAddon([])
        }} />

        <MaintenanceModal
          isOpen={showMaintenanceModal}
          onClose={() => setShowMaintenanceModal(false)}
        />
      </div >
    );
  }
}


export default VenueDetail;